import { bindable } from 'aurelia-framework';

class App {
  @bindable isMenuVisible = false;
}

export { App };
